const { debounce } = window.BAO.Utils

class ScaleImage extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false

    this.scrollElement = this.closest('[data-scroller]')

    this.lastKnownY = this.scrollElement.scrollTop
    this.elementOffsetTop =
      this.getBoundingClientRect().top + this.scrollElement.scrollTop

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setAttribute('active', '')

    this.setWidth()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.closest('[data-scroller]').addEventListener('scroll', this.onScroll, {
      passive: true,
    })

    this.setWidth = this.setWidth.bind(this)
    this.listeners.add(window, 'resize', debounce(this.setWidth, 200))
  }

  setWidth () {
    const width = this.offsetWidth

    this.style.setProperty('--width', `${width}px`)
  }

  onScroll () {
    this.lastKnownY = this.scrollElement.scrollTop
    this.elementOffsetTop =
      this.getBoundingClientRect().top + this.scrollElement.scrollTop

    this.imageEndsParallaxing = this.closest(
      '[data-scale-image-wrapper]',
    ).getBoundingClientRect().top

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setWidth()
    this.scaleMedia()
    this.toggleParallax()
  }

  toggleParallax () {
    if (
      !this.hasAttribute('data-parallax') ||
      this.imageEndsParallaxing === undefined
    ) { return }

    this.classList.toggle(
      this.dataset.fixedClass,
      this.imageEndsParallaxing > 50,
    )
  }

  scaleMedia () {
    if (
      (window.BAO.MediaBreakpoints.isXsViewport &&
        this.dataset.mobileScale === 0) ||
      (window.BAO.MediaBreakpoints.isSm && this.dataset.desktopScale === 0)
    ) {
      return
    }

    const maxScale = window.BAO.MediaBreakpoints.isXsViewport
      ? this.dataset.mobileScale
      : this.dataset.desktopScale

    const imageStartsParallaxing =
      this.elementOffsetTop -
      this.scrollElement.offsetHeight -
      this.offsetHeight
    const imageEndsParallaxing =
      imageStartsParallaxing +
      this.scrollElement.offsetHeight +
      this.offsetHeight
    const totalScrollAmount = imageEndsParallaxing - imageStartsParallaxing

    if (this.lastKnownY < imageStartsParallaxing) {
      this.style.setProperty('--scale', maxScale)

      return
    }

    if (this.lastKnownY > imageEndsParallaxing) {
      this.style.setProperty('--scale', 1)

      return
    }

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - imageStartsParallaxing) / totalScrollAmount
    const scaleAmount =
      maxScale - (maxScale - 1) * scrollYAsAPercentageOfJourney

    this.style.setProperty('--scale', scaleAmount)
  }
}

if (!customElements.get('scale-image')) {
  customElements.define('scale-image', ScaleImage)
}
